module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/mentors__07-0c718d5ca48ac09716190a68c9d520fb.jpg";